import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PresentationFile"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 3H12.75V1.5H11.25V3H5.25C4.42157 3 3.75 3.67157 3.75 4.5V15C3.75 15.8284 4.42157 16.5 5.25 16.5H11.25V21H8.25V22.5H15.75V21H12.75V16.5H18.75C19.5784 16.5 20.25 15.8284 20.25 15V4.5C20.25 3.67157 19.5784 3 18.75 3ZM18.75 15H5.25V4.5H18.75V15ZM12.75 7.5H11.25V13.5H12.75V7.5ZM15 10.5H16.5V13.5H15V10.5ZM9 9H7.5V13.5H9V9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PresentationFile.vue"]]);
